import { Injectable, Inject } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Router } from '@angular/router';

import { Observable, Subject, ReplaySubject } from 'rxjs';


import { UserInfoService, LoginInfoInStorage } from './user-info.service';
import { ApiRequestService } from './api-request.service';
import { AgentService } from './agent.service'
import { ChangePassService } from './change-pass.service';
import { AppMetadataHandler } from 'app/BaseFramework/configs';

export interface LoginRequestParam {
    userId: string;
    password: string;
}

@Injectable()
export class LoginService {

    // public landingPage:string = "/home/dashboard/order";
    public landingPage: string = "/app/dash";
    constructor(
        private router: Router,
        private userInfoService: UserInfoService,
        private apiRequest: ApiRequestService,
        private agentService: AgentService,
        private changePassService: ChangePassService,
        private appMetaDataHandler: AppMetadataHandler
    ) { }


    getToken(userId: string, password: string): Observable<any> {
        let me = this;
        // Object that we want to send back to Login Page
        let loginInfoReturn: LoginInfoInStorage = {
            "success": false,
            "message": "Unsuccessful login",
            "landingPage": "/login",
            "user": {
                "userId": null,
                "firstName": null,
                "email": null,
                "displayName": null,
                "token": null,
                "oneTimePasswordFl": false,
                "statusCd": null,
                "typeCd": null,
                "userRoleDOList": [],
                "userObjectResp": null,
                "baseCompanyCd": null
            }
        };


        let bodyData: LoginRequestParam = {
            "userId": userId,
            "password": this.changePassService.encrypted(password)
        }
        let loginDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax login attempt

        this.apiRequest.authenticate('', bodyData)
            .subscribe(jsonResp => {
                // if (jsonResp !== undefined && jsonResp !== null && jsonResp.operationStatus === "SUCCESS"){
                if (jsonResp !== undefined && jsonResp.responseCode === 'SUCCESS') {
                    // this.agentService.SetAgent(jsonResp.user);
                    
                    if (jsonResp.user.exceptionDOList 
                        && jsonResp.user.exceptionDOList != null 
                        && jsonResp.user.exceptionDOList.length > 0 
                        && jsonResp.user.exceptionDOList[0] != null){
                        jsonResp.user.oneTimePasswordFl = true;
                    }

                    //Fill in the success object that we want to send back to login page
                    loginInfoReturn.success = true;
                    loginInfoReturn.message = jsonResp.Message
                    loginInfoReturn.landingPage = this.landingPage
                    loginInfoReturn.user.userId = bodyData.userId
                    loginInfoReturn.user.firstName = jsonResp.user.firstName
                    loginInfoReturn.user.email = jsonResp.user.emailId
                    loginInfoReturn.user.displayName = jsonResp.user.firstName
                    loginInfoReturn.user.oneTimePasswordFl = jsonResp.user.oneTimePasswordFl
                    loginInfoReturn.user.statusCd = jsonResp.user.statusCd
                    loginInfoReturn.user.typeCd = jsonResp.user.typeCd
                    loginInfoReturn.user.baseCompanyCd = jsonResp.user.baseCompanyCd
                    loginInfoReturn.user.userRoleDOList = jsonResp.user.userRoleDOList

                    //Pentest Caution: Might be a Pentest Issue
                    loginInfoReturn.user.userObjectResp = jsonResp.user
                    loginInfoReturn.user.token = this.apiRequest.token

                    // store userId and jwt token in session storage to keep user logged in between page refreshes
                    this.userInfoService.storeUserInfo(JSON.stringify(jsonResp.user));
                
                    // fetch company details by baseCompanyCd;
                    if (loginInfoReturn.user.baseCompanyCd)
                        this.fetchCompanyByNum(loginInfoReturn.user.baseCompanyCd);
                }
                else if (jsonResp !== undefined && jsonResp.responseCode === 'ERROR') {
                    //Create a faliure object that we want to send back to login page
                    loginInfoReturn = this.getEmptyLoginInfo(bodyData.userId)

                }
                loginDataSubject.next(loginInfoReturn);
            }, errResp => {
                //Create a faliure object that we want to send back to login page
                loginInfoReturn = this.getEmptyLoginInfo(bodyData.userId)
                loginDataSubject.next(errResp);
            });

        return loginDataSubject;
    }

    logout(navigatetoLogout = true): void {
        // clear token remove user from local storage to log user out
        //local and session storage
        this.userInfoService.removeUserInfo();
        if (navigatetoLogout) {
            this.router.navigate(["logout"]);
        }
    }

    getEmptyLoginInfo(userId) {
        var loginInfoReturn = {
            "success": false,
            "message": "Unsuccessful login",
            "landingPage": "/login",
            "user": {
                "userId": userId,
                "firstName": null,
                "email": null,
                "displayName": null,
                "token": null,
                "oneTimePasswordFl": false,
            }
        };

        return loginInfoReturn
    }

    logoutAgent() {
        let logoutResponce = null;
        this.apiRequest.getCallWithAPIMapper('logout')
            .subscribe(jsonResp => {
                logoutResponce = jsonResp;
                localStorage.clear();
                sessionStorage.clear();
                this.userInfoService.removeUserInfo();
                this.router.navigate(['/login']);
            });
    }
    testAuth(userId: string, password: string): Observable<any> {
        let me = this;
        let loginDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax login attempt
        let loginInfoReturn: LoginInfoInStorage; // Object that we want to send back to Login Page

        this.apiRequest.get('mobile/auth')
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {


                }
            });

        return loginDataSubject;
    }

    logoutTest(userId: string, password: string): Observable<any> {
        let me = this;
        let loginDataSubject: Subject<any> = new Subject<any>(); // Will use this subject to emit data that we want after ajax login attempt
        let loginInfoReturn: LoginInfoInStorage; // Object that we want to send back to Login Page

        this.apiRequest.get('mobile/auth')
            .subscribe(jsonResp => {
                if (jsonResp !== undefined) {


                }
            });

        return loginDataSubject;
    }

    submitPasswordResetRequest(userId, currentPassword, newPassword) {
        let resetPayload = {
            size: 20,
            searchCriteriaList: [
                {
                    paramName: "currenPass",
                    paramValue: this.changePassService.encrypted(currentPassword)
                },
                {
                    paramName: "confirmPass",
                    paramValue: this.changePassService.encrypted(newPassword)
                },
                {
                    paramName: "userId",
                    paramValue: userId
                }
            ]
        }

        let resetResponse$: Subject<any> = new Subject<any>();

        this.apiRequest.postCallWithAPIMapper('changePassword', resetPayload)
            .subscribe(resp => {
                resetResponse$.next(resp);
            });
        
        return resetResponse$;
    }

    fetchCompanyByNum(companyNum) {
        let pathVariables = [companyNum];
        let url = `user-service/company/fetch-by-companyNum/${companyNum}`
        // let url = 'fetchByCompanyNum';
        this.apiRequest.get(url).subscribe(companyResp=>{
            console.log("company details", companyResp);
            if(companyResp && companyResp.companyMasterDO) {
                this.appMetaDataHandler.companyCurrencyCd = companyResp.companyMasterDO.currencyCd;
                this.appMetaDataHandler.GLOBAL_DATE_FORMAT_ANGULAR = companyResp.companyMasterDO.dateFormatCd || "dd MMM yyyy";
                this.appMetaDataHandler.GLOBAL_DATE_FORMAT_MOMENT = companyResp.companyMasterDO.dateFormatCd || "dd MMM yyyy";
            }
        })
    }


}